import "./App.tag"
import "./Syntax.tag"
import "./ComponentDemo.tag"
import "./Demos"



// WEBPACK FOOTER //
// ./docs/riot/components/index.js